export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8062.c6955473.jpg";